<template>
  <div class="video-player" ref="control" @touchstart="touchEnterVideo"
      @touchend="touchLeaveVideo">
    <!-- 播放器界面; 兼容ios  controls-->
    <video
      ref="video"
      :id="id"
      webkit-playsinline="true"
      playsinline="true"
      x-webkit-airplay="true"
      preload="auto"
      class="control"
      x5-video-player-type="h5"
      x5-video-player-fullscreen="true"
      x5-video-orientation="portraint"
      :poster="poster"
      :src="src"
    >您的浏览器不支持HTML5</video>

      <!-- 播放 || 暂停 || 加载中-->
      <div class="play" @touchstart.stop="clickPlayBtn" v-if="state.controlBtnShow">
        <img
          v-if="!state.playing&&!state.isLoading"
          :src="require('assets/img/common/play.svg')"
        >
        <img
          v-if="state.playing&&!state.isLoading"
          :src="require('assets/img/common/pause.svg')"
        >
        <div class="loader" v-if="state.isLoading">
          <div class="loader-inner ball-clip-rotate">
            <div></div>
          </div>
        </div>
      </div>
      <div class="control-bar">
        <span class="time">{{video.displayTime}}/{{video.totalTime}}</span>
        <!-- <span class="full-screen" @click="fullScreen">
          <img src="@/assets/img/common/full.svg" alt>
        </span> -->
      </div>
    <!-- 错误弹窗 -->
    <div class="error" v-show="state.isError">
      <p class="lose">视频加载失败</p>
      <p class="retry" @click="retry">点击重试</p>
    </div>
  </div>
</template>
<script>
  import './index.less'
  import { throttle } from "@/libs/tool";
  const pad = val => {
    val = Math.floor(val);
    if (val < 10) {
      return "0" + val;
    }
    return val + "";
  };
  const timeParse = sec => {
    let min = 0;
    min = Math.floor(sec / 60);
    sec = sec - min * 60;
    return pad(min) + ":" + pad(sec);
  };
  export default {
    name: "t-video",
    props: {
      src: {
        type: String,
        required: true
      },
      poster:{
        type: String,
        required: true
      },
      showVideo: {
        // 兼容android弹出层
        type: Boolean,
        default: true
      },
      id:String
    },

    data() {
      return {
        // video元素
        $video: null,
        // 视频容器元素
        player: {
          $player: null,
          pos: null
        },
        // progress进度条元素
        progressBar: {
          $progress: null, // 进度条DOM对象
          pos: null
        },
        // video控制显示设置
        video: {
          loaded: 0, // 缓存长度
          displayTime: "00:00", // 进度时间
          totalTime: "00:00", // 总时间
          progress: {
            width: 0, // 进度条长度
            current: 0 // 进度条当前位置
          }
        },
        // 定时器
        hideTimer: null,
        // 播放状态控制
        state: {
          controlBtnShow: true, // 播放按钮
          controlBarShow: false, // 控制条
          fullScreen: false,
          playing: false,
          isLoading: false,
          isEnd: false,
          isError: false
        },
        // 首次触摸
        isFirstTouch: true,
        // 暂停状态触摸
        isPauseTouch: false,
        only:false
      };
    },
    methods: {
      init() {
        // 初始化video,获取video元素       
        this.$video = this.$el.getElementsByTagName("video")[0];
        // this.$video = document.getElementById(this.id);
        // this.$video = this.$refs["video"];
        this.initPlayer();
      
      },
      // 初始化播放器容器, 获取video-player元素
      // getBoundingClientRect()以client可视区的左上角为基点进行位置计算
      initPlayer() {
        this.$video.addEventListener("click", () => { // 点击视频区域可以进行播放或者暂停
          if(this.$video.paused || this.$video.ended) {
            if(this.$video.ended) {
              // 如果视频结束，currentTime初始化为0
              this.src = this.src
              this.$video.currentTime = 0
              
            }
            this.state.controlBtnShow = false;
              this.$video.play();//调用下面play的方法
              this.$video.addEventListener(
                "timeupdate",
                throttle(this.getPlayTime, 100, 1)
              );
              this.send();
              // 监听结束
              this.$video.addEventListener("ended", e => {
                // 重置状态
                this.state.playing = false;
                this.state.isEnd = true;
                this.state.controlBtnShow = true;
                this.video.displayTime = "00:00";
                this.video.progress.current = 0;
                this.$video.currentTime = 0;
                this.src = this.src
                this.$emit("send", '已发送');
              });
          } else {
            this.$video.pause(); //调用下面pause的方法
            this.state.controlBtnShow = true;
            this.send1();
          }
          this.state.playing = !this.state.playing;
        })

      },
      send() {      
        if(this.only) return;  
        let duration = this.$video.duration
        let currentTime = duration/2
        this.only = true
        let that = this
        setTimeout(() => {
          that.$emit("send", '已发送');
        }, currentTime*1000);
      },
      send1() {
        let duration = this.$video.duration
        let currentTime = this.$video.currentTime
        if(currentTime>=duration/2) this.$emit("send", '已发送');
      },
      // 点击播放 & 暂停按钮
      clickPlayBtn() {
        if (this.state.isLoading) return;
        this.isFirstTouch = false;
        this.state.playing = !this.state.playing;
        this.state.isEnd = false;
          // 播放状态
        if (this.state.playing) {
          try {
            this.$video.play();
            this.send();
            this.isPauseTouch = false;
            // 监听播放进度
            this.$video.addEventListener(
              "timeupdate",
              throttle(this.getPlayTime, 100, 1)
            );
            // 监听结束
            this.$video.addEventListener("ended", e => {
              // 重置状态
              this.state.playing = false;
              this.state.isEnd = true;
              this.state.controlBtnShow = true;
              this.video.displayTime = "00:00";
              this.video.progress.current = 0;
              this.$video.currentTime = 0;
              this.src = this.src
              this.$emit("send", '已发送');
            });
          } catch (e) {
            // 捕获url异常出现的错误
          }
        }
        // 停止状态
        else {
          this.isPauseTouch = true;
          this.$video.pause();
          this.send1();
        }
      },
      // 触碰播放区
      touchEnterVideo() {       
        if (this.isFirstTouch) return;
        if (this.hideTimer) {
          clearTimeout(this.hideTimer);
          this.hideTimer = null;
        }        
        this.state.controlBtnShow = true;
        // this.state.controlBarShow = true;
      },
      // 离开播放区
      touchLeaveVideo() {
        if (this.isFirstTouch) return;
        if (this.hideTimer) {
          clearTimeout(this.hideTimer);
        }
        // 暂停触摸, 不隐藏
        if (this.isPauseTouch) {
          this.state.controlBtnShow = true;
          // this.state.controlBarShow = true;
        } else {
          this.hideTimer = setTimeout(() => {
            // this.state.controlBarShow = false;
            // 加载中只显示loading
            if (this.state.isLoading) {
              this.state.controlBtnShow = true;
            } else {
              this.state.controlBtnShow = false;
            }
            this.hideTimer = null;
          }, 3000);
        }
      },
      // 获取播放时间
      getPlayTime() {
        const percent = this.$video.currentTime / this.$video.duration;
        this.video.progress.current = Math.round(
          this.video.progress.width * percent
        );
        // 赋值时长
        this.video.totalTime = timeParse(this.$video.duration);
        this.video.displayTime = timeParse(this.$video.currentTime);
      },
      // 点击重新加载
      retry() {
        this.state.isError = false;
        this.init();
      },
      // 设置全屏
      fullScreen() {
        console.log('点击全屏...');
        if (this.$video.requestFullscreen) {
          this.$video.requestFullscreen()
        } else if (this.$video.mozRequestFullScreen) {
          this.$video.mozRequestFullScreen()
        } else if (this.$video.webkitRequestFullScreen) {
          this.$video.webkitRequestFullScreen()
        }
        // 对应的video标签大小100%
        this.$refs['video'].style.width = "100%"
        this.$refs['video'].style.height = "100%"
        // if (!this.state.fullScreen) {
        //   this.state.fullScreen = true;
        //   this.$video.webkitRequestFullScreen();
        // } else {
        //   this.state.fullScreen = false;
        //   document.webkitCancelFullScreen();
        // }
      },
    },
    mounted() {
      let that = this;
      setTimeout(() => {
        that.init();
      }, 100);
    }
  };
</script>